import React from "react";
import "./DeleteOverlay.css";

const DeleteOverlay = (props) => {
  return (
    <div className={`overlay ${props.isVisible ? "visible" : ""}`}>
      <div className="overlay-content">
        <h2 className="heading">Delete</h2>

        <p className="overlay-txt">
          Are you sure you want to delete the section?
        </p>

        <hr className="div-line" />

        <button className="deleteBtn" onClick={props.handleDelete} disabled={props.loading} style={{color: '#fff'}}>
          {props.loading ? (
            <div className="spinner"></div>
          ) : (
            <span className="del-txt">Delete</span>
          )}
        </button>

        <hr className="div-line" />

        <button className="deleteBtn" onClick={props.onBackdropPress} style={{backgroundColor: '#032c56', color:'#fff'}}>
          Cancel
        </button>
      </div>
    </div>
  );
};

export default DeleteOverlay;
